var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"join"},[_c('p',[_vm._v(_vm._s(_vm.state.lan.join.title))]),_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.$router.push('/sign-up')}}},[_vm._v(_vm._s(_vm.state.lan.join.btn))])])}
var staticRenderFns = []

export { render, staticRenderFns }